/**
 * Small library full of little helpers to create more libraries.
 *
 * @packageDocumentation
 */
/* istanbul ignore file */
import { registerLibrary } from '@onviobr/app-information';
export { isTestEnv } from './test-env.js';
export { mapKey, mapKeyDefault, ensureMap, diffMap, syncMap } from './maps.js';
export { lastValueFrom } from './observables.js';
export { BaseHttpClientV1, HttpError, JSON_REQUEST_HEADERS } from './base-http-client.js';
export { deferred } from './deferred.js';
registerLibrary({
    name: '@onviobr/helpers',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "2.1.0",
});
